export default {
  order: 2,
  layerGroupId: 'GROUP_LCD',
  dataLayer: {
    id: 'TREE_COVER_GAIN',
    order: 2,
    type: 'remoteDataLayer',
    uuid: 'cb016f17-f12d-463a-9dc2-aabcf5db566c',
    groupId: 'GROUP_LCD',
  },
  layer: {
    metadata: {
      metadata: null,
      legendConfig: {
        type: 'basic',
        name: {
          en: 'Tree cover gain (2000 - 2020)',
          fr: 'Gain en couvert arboré (2000 - 2020)',
          es: 'Ganancia de cobertura arbórea (2000 - 2020)',
          pt: 'Ganho de cobertura arbórea (2000 - 2020)',
          id: 'Perolehan tutupan pohon (2000 - 2020)',
          zh: '森林覆盖增加 (2000 - 2020)',
          ka: 'ხის ვარჯის ნამატი (2000 - 2020)',
        },
        source: '(12 years, 30m, global, Hansen/UMD/Google/USGS/NASA)',
        items: [
          {
            name: {
              en: 'Tree cover gain',
              fr: 'Gain de la couverture arborée',
              es: 'Ganancia de cobertura arbórea',
              pt: 'Ganho de cobertura arbórea',
              id: 'Perolehan tutupan pohon',
              zh: '森林覆盖增加',
              ka: 'ხის ვარჯის ნამატი',
            },
            color: '#4600ff',
            outlineColor: '#555555',
          },
        ],
      },
      interactionConfig: {},
    },
    id: 'TREE_COVER_GAIN',
    type: 'gain',
    url: 'https://tiles.globalforestwatch.org/umd_tree_cover_gain_from_height/v202206/mode/{z}/{x}/{y}.png',
    technicalName: 'tree_cover_gain',
    label: {
      en: 'Tree cover gain',
      fr: 'Gain de la couverture arborée',
      es: 'Ganancia de cobertura arbórea',
      pt: 'Ganho de cobertura arbórea',
      id: 'Perolehan tutupan pohon',
      zh: '森林覆盖增加',
      ka: 'ხის ვარჯის ნამატი',
    },
    sublabel: {
      en: '(2000 – 2020, 30m, global, Hansen/UMD/Google/USGS/NASA)',
      fr: '(2000 – 2020, 30 m, mondiale, Hansen/UMD/Google/USGS/NASA)',
      es: '(2000 a 2020, 30 m, global, Hansen/UMD/Google/USGS/NASA)',
      pt: '(2000 – 2020, 30 m, global, Hansen/UMD/Google/USGS/NASA)',
      id: '(2000 – 2020, 30m, global, Hansen/UMD/Google/USGS/NASA)',
      zh: '(2000 – 2020 年，30m，全球，Hansen/UMD/Google/USGS/NASA）',
      ka: '(2000 – 2020, 30 მ, გლობალური, Hansen/UMD/Google/USGS/NASA)',
    },
  },
  isMetadataError: false,
  isError: false,
};
